import { Features, TimerChunk, ViewMode } from '../../api/types/types';
import * as Styled from './styled';
import {
    FilledInput,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Tooltip,
    withStyles
} from '@material-ui/core';
import HomeStore, { SegmentViewMode } from 'store/home.store';
import { Close, Delete, Flip, Refresh, Timer, Visibility } from '@material-ui/icons';
import { CaptureSegmentsList } from 'components/CaptureSegmentsList/CaptureSegmentsList';
import { SegmentExpansion } from 'components/CaptureSegmentsList/SegmentExpansion';
import { FeaturesConsumer } from 'common/FeaturesProvider';
import * as React from 'react';
import { LoadingDiv } from './Home';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import { withTranslation } from 'react-i18next';

const BootstrapInput = withStyles(theme => ({
    input: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.primary.contrastText,
        paddingBottom: 3,
        fontSize: 12,
        '&:focus': {
            backgroundColor: theme.palette.secondary.contrastText,
            color: theme.palette.primary.contrastText
        }
    },
}))(FilledInput);

interface Props {
    toggleTCView: boolean;
    homeStore?: HomeStore;
    // tslint:disable:no-any
    classes?: any;
    t: any;
    // tslint:enable:no-any
}
@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        homeStore: rootStore.homeStore,
        timerStore: rootStore.timerStore
    }
})
@observer
class SegmentsView extends React.Component<Props> {
    render() {
        const { toggleTCView, classes, t, homeStore } = this.props;
        const {
            calendarMode,
            segmentViewMode,
            toggleSegmentGaps,
            showSegmentGaps,
            showUsedSegments,
            toggleShowProcessedSegments,
            segmentsLoading,
            refreshSegments,
            showTimersPane,
            toggleTimers,
            hasSelectedAtLeastOneGroup,
            deleteSegments,
            selectedSegments,
            selectedTimerSegments,
            deselectAllSegments,
            toggleSegmentViewMode,
            filteredApplicationTypeSegments,
            filteredChronologicalSegments,
            filteredTimeTypeSegments,
            getProgram,
            toggleSegmentGroupOrGapSelection,
            isSelected,
            selectSameWindows,
            toggleApplicationExpansion,
            updateTimeEntryFromDragSource,
            toggleTimeGroupExpansion,
            getProgramColor,
            captureChunkObservables,
            filteredDayViewTimers,
            toggleTimerSelection,
            expandedTimers,
            toggleTimerExpansion,
            isSelectedTimerSegment,
            openTimeEntryFromTimerSegment
        } = homeStore!;
        
        return (
            <FeaturesConsumer>
                {(features: Features) => features.EpochConfigTimeCastEnabled &&
                    calendarMode !== ViewMode.WEEK && toggleTCView && (
                        <Styled.CapturedSegmentsContainer>
                            <Styled.CapturedSegmentsControls>
                                <Tooltip title={t('view.day.segment_panel.header.action.gap.tooltip')}>
                                    <Styled.SegmentIconButton
                                        disabled={segmentViewMode !== SegmentViewMode.CHRONOLOGICAL}
                                        onClick={toggleSegmentGaps}
                                    >
                                        <Flip data-active={showSegmentGaps}/>
                                    </Styled.SegmentIconButton>
                                </Tooltip>
                                <Tooltip
                                    title={showUsedSegments
                                        ? t('view.day.segment_panel.header.action.used.tooltip.hide')
                                        : t('view.day.segment_panel.header.action.used.tooltip.show')}
                                >
                                    <Styled.SegmentIconButton onClick={toggleShowProcessedSegments}>
                                        <Visibility data-active={showUsedSegments}/>
                                    </Styled.SegmentIconButton>
                                </Tooltip>
                                <Tooltip title={t('view.day.segment_panel.header.action.refresh.tooltip')}>
                                    <Styled.SegmentIconButton
                                        disabled={segmentsLoading}
                                        onClick={() => refreshSegments()}
                                    >
                                        <Refresh/>
                                    </Styled.SegmentIconButton>
                                </Tooltip>
                                <Tooltip title={t('view.day.segment_panel.header.action.timer.tooltip')}>
                                    <Styled.SegmentIconButton onClick={showTimersPane}>
                                        <Timer data-active={toggleTimers}/>
                                    </Styled.SegmentIconButton>
                                </Tooltip>
                                {
                                    hasSelectedAtLeastOneGroup &&
                                    <Tooltip title={t('delete', { ns: 'common' })}>
                                        <Styled.SegmentIconButton onClick={deleteSegments}>
                                            <Delete/>
                                        </Styled.SegmentIconButton>
                                    </Tooltip>
                                }
                                {(selectedSegments.length > 0 || selectedTimerSegments.length > 0) &&
                                <Tooltip title={t('deselect_all', { ns: 'common' })}>
                                    <Styled.SegmentIconButton onClick={deselectAllSegments}>
                                        <Close/>
                                    </Styled.SegmentIconButton>
                                </Tooltip>}
                                {!toggleTimers &&
                                <FormControl variant={'filled'} className={classes.groupByForm}>
                                    <InputLabel
                                        shrink={true}
                                        FormLabelClasses={{
                                            root: classes.groupByLabel
                                        }}
                                    >
                                        {t('view.day.segment_panel.header.field.group_by.label')}
                                    </InputLabel>
                                    <Select
                                        input={
                                            <BootstrapInput
                                                name={'groupBy'}
                                                id={'group-label-placeholder'}
                                            />}
                                        displayEmpty={true}
                                        name={'select-status'}
                                        value={SegmentViewMode[segmentViewMode]}
                                        onChange={toggleSegmentViewMode}
                                    >
                                        <MenuItem value={'CHRONOLOGICAL'}>{t('view.day.segment_panel.header.field.group_by.option.none')}</MenuItem>
                                        <MenuItem value={'APPLICATION_TYPE'}>{t('view.day.segment_panel.header.field.group_by.option.application')}</MenuItem>
                                        <MenuItem value={'TIME_TYPE'}>{t('view.day.segment_panel.header.field.group_by.option.time')}</MenuItem>
                                    </Select>
                                </FormControl>}
                            </Styled.CapturedSegmentsControls>
                            {/*{segmentsLoading*/}
                            {/*    ? <LinearProgressBar color={'primary'} progressBar={50}/>*/}
                            {/*    : <div style={{backgroundColor: '#444'}}/>}*/}
                            <Styled.CapturedSegmentsListContainer>
                                <Styled.SegmentsPane>
                                    {(filteredChronologicalSegments.length > 0 ||
                                        Object.keys(filteredApplicationTypeSegments).length > 0 ||
                                        Object.keys(filteredTimeTypeSegments).length > 0
                                    ) ?
                                        <CaptureSegmentsList
                                            segmentViewMode={segmentViewMode}
                                            filteredApplicationTypeSegments={filteredApplicationTypeSegments}
                                            filteredChronologicalSegments={filteredChronologicalSegments}
                                            filteredTimeTypeSegments={filteredTimeTypeSegments}
                                            getProgram={getProgram}
                                            toggleSegmentGroupOrGapSelection={toggleSegmentGroupOrGapSelection}
                                            isSelected={isSelected}
                                            selectSameWindows={selectSameWindows}
                                            toggleApplicationExpansion={toggleApplicationExpansion}
                                            updateTimeEntryFromDragSource={updateTimeEntryFromDragSource}
                                            toggleTimeGroupExpansion={toggleTimeGroupExpansion}
                                            getProgramColor={getProgramColor}
                                            LoadingDiv={LoadingDiv}
                                            observables={captureChunkObservables}
                                        />
                                        :
                                        <div>{t('segment.list.empty')}</div>
                                    }
                                </Styled.SegmentsPane>
                                {toggleTimers &&
                                <Styled.SegmentsPane>
                                    {filteredDayViewTimers.length > 0 ?
                                        filteredDayViewTimers.slice().sort().map((timer, index) =>
                                            <SegmentExpansion
                                                key={index}
                                                toggleSelection={toggleTimerSelection}
                                                isSelected={(group: TimerChunk) => isSelectedTimerSegment(group)}
                                                expanded={expandedTimers.includes(timer.id!)}
                                                toggleExpansion={() => toggleTimerExpansion(timer.id!)}
                                                selectedSegmentsToDrag={
                                                    selectedTimerSegments.length + selectedSegments.length
                                                }
                                                onDrop={updateTimeEntryFromDragSource}
                                                timer={timer}
                                                timeEntryOpen={openTimeEntryFromTimerSegment}
                                            />) :
                                        <div>{t('segment.list.empty')}</div>
                                    }
                                </Styled.SegmentsPane>
                                }
                            </Styled.CapturedSegmentsListContainer>

                        </Styled.CapturedSegmentsContainer>
                    )}
            </FeaturesConsumer>
        )
    }
}

export default withTranslation(['home', 'common'])(SegmentsView);